(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["saif-policy-layout"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('saif-policy-layout')) {
    class SaifPolicyLayout extends HTMLElement {
      connectedCallback() {
        if (this.dataset.formatted) return;
        this.dataset.formatted = 'true';
        const menu = this.querySelector('.saif-policy-menu');
        if (menu) menu.open = window.matchMedia('(min-width: 990px)').matches;

        const root = this.querySelector('.shopify-policy__body .rte');
        if (!root) return;
        const title = this.querySelector('.shopify-policy__title h1')?.textContent.trim().toLowerCase();
        const repeatedTitle = root.querySelector('h1');
        if (repeatedTitle?.textContent.trim().toLowerCase() === title) repeatedTitle.remove();

        const seen = new Set();
        const paragraphs = [...root.querySelectorAll('p')];
        for (const paragraph of paragraphs.toReversed()) {
          const signature = paragraph.innerHTML.trim();
          if (!paragraph.textContent.trim() && !paragraph.querySelector('img, video, iframe')) {
            paragraph.remove();
          } else if (signature.length > 200 && seen.has(signature)) {
            paragraph.remove();
          } else {
            seen.add(signature);
          }
        }

        for (const paragraph of root.querySelectorAll('p')) {
          if (!paragraph.querySelector('br')) continue;
          const fragment = document.createDocumentFragment();
          let current = document.createElement('p');
          const flush = () => {
            if (current.textContent.trim() || current.querySelector('img, a')) fragment.append(current);
            current = document.createElement('p');
          };
          const nodes = [...paragraph.childNodes];
          for (let index = 0; index < nodes.length; index++) {
            const node = nodes[index];
            if (node.nodeName === 'BR') {
              flush();
              continue;
            }
            const next = nodes.slice(index + 1).find(item => item.nodeType !== Node.TEXT_NODE || item.textContent.trim());
            if (node.nodeName === 'STRONG' && !current.textContent.trim() && next?.nodeName === 'BR') {
              flush();
              const heading = document.createElement('h2');
              heading.append(...node.childNodes);
              fragment.append(heading);
            } else {
              current.append(node);
            }
          }
          flush();
          paragraph.replaceWith(fragment);
        }

        const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
        const references = [];
        while (walker.nextNode()) {
          if (walker.currentNode.textContent.includes('[LINK]') && !walker.currentNode.parentElement.closest('a')) {
            references.push(walker.currentNode);
          }
        }
        for (const node of references) {
          const text = node.textContent;
          const fragment = document.createDocumentFragment();
          let offset = 0;
          for (const match of text.matchAll(/(Privacy Policy|Refund Policy|here)\s+\[LINK\]/gi)) {
            const href = match[1].toLowerCase() === 'refund policy' ? this.dataset.refundUrl : this.dataset.privacyUrl;
            if (!href) continue;
            fragment.append(document.createTextNode(text.slice(offset, match.index)));
            const link = document.createElement('a');
            link.href = href;
            link.textContent = match[1];
            fragment.append(link);
            offset = match.index + match[0].length;
          }
          if (offset) {
            fragment.append(document.createTextNode(text.slice(offset)));
            node.replaceWith(fragment);
          }
        }
      }
    }
    customElements.define('saif-policy-layout', SaifPolicyLayout);
  }
  } catch(e) { console.error(e); }
})();

})();
